import script from "./Sidenav.vue?vue&type=script&setup=true&lang=js"
export * from "./Sidenav.vue?vue&type=script&setup=true&lang=js"

import "./Sidenav.vue?vue&type=style&index=0&id=5f7484e4&scoped=true&lang=css"

import exportComponent from "/Users/dioratar/Documents/_project/omni/repo/emetrai/event-panel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f7484e4"]])

export default __exports__